var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticClass:"header",attrs:{"height":"auto"}},[_c('SupportHeader')],1),_c('el-main',{staticClass:"content"},[_c('transition',{attrs:{"name":"slide"}},[_c('router-view')],1)],1),_c('el-footer',[_c('newFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }